











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Option} from '@/types/gripper';

@Component({})

export default class OptionButtonItem extends Vue {

  @Prop(Object) public option!: Option;
  @Prop(Object) public currentOption!: Option;
  @Prop(Number) public index!: number;

  get itemIsChecked() {
    if (!this.currentOption) {
      return false;
    }

    return this.currentOption.value === this.option.value;
  }

  private checkItem(option: Option) {
    this.$emit('onClickChangeOption', option);
  }

}
